// extracted by mini-css-extract-plugin
export default {"container":"ContactApp_container__r+F9B","head":"ContactApp_head__acY1a"};